import { render, staticRenderFns } from "./SideDialogProduct.vue?vue&type=template&id=58b4b156&scoped=true&"
import script from "./SideDialogProduct.vue?vue&type=script&lang=js&"
export * from "./SideDialogProduct.vue?vue&type=script&lang=js&"
import style0 from "./SideDialogProduct.vue?vue&type=style&index=0&id=58b4b156&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b4b156",
  null
  
)

component.options.__file = "SideDialogProduct.vue"
export default component.exports